import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { track } from '../lib/analytics';

export default function AlpacaSuccess() {
  useEffect(() => {
    track('alpaca_connected', { env: 'paper' });
  }, []);
  return (
    <div className="min-h-screen bg-[#0a0a0b] flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-5 py-16">
        <div className="w-full max-w-lg text-center">
          <div className="w-14 h-14 mx-auto rounded-full border border-emerald-500/40 bg-emerald-500/[0.06] flex items-center justify-center">
            <CheckCircle2 size={26} className="text-emerald-400" strokeWidth={1.6} />
          </div>
          <p className="mt-6 text-[10px] tracking-[0.25em] font-mono text-emerald-400">CONNECTED</p>
          <h1 className="font-display mt-3 text-3xl sm:text-4xl font-bold text-white leading-tight">
            Your Alpaca paper account<br /><span className="gold-text">is connected.</span>
          </h1>
          <p className="mt-5 text-sm text-zinc-400 leading-relaxed">
            Talas beta can now show paper signals and, if enabled later, test paper execution. <span className="text-zinc-200">No live funds are used during beta.</span>
          </p>
          <div className="mt-9 flex flex-col sm:flex-row sm:justify-center gap-3">
            <Link
              to="/dashboard?alpaca=connected"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-[#d8b34a] text-black font-semibold text-sm rounded-sm hover:bg-[#e6c365] transition-colors"
            >
              Go to Dashboard <ArrowRight size={14} />
            </Link>
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 border border-white/15 text-zinc-200 hover:border-[#d8b34a]/60 hover:text-white rounded-sm text-sm transition-colors"
            >
              Back to Home
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
